const mutations = {
    updateTab: (state, value) => state.activeIndex = value
}

export default mutations;
